import * as React from 'react';
import { compose } from 'recompose';
import { withAnalyticOnView, enrichAnalytics } from 'react-shisell';
import withPageMeasurement from './behaviors/withPageMeasurement';

export type PageProps = React.HTMLAttributes<HTMLDivElement> & {
  pageName: string;
  mapPropsToExtras?: (props: any) => object;
};

const Page: React.SFC<PageProps> = ({ children, className }) => <div className={className}>{children}</div>;

export default compose<{}, PageProps>(
  enrichAnalytics<PageProps>((dispatcher, { pageName }) => dispatcher.withExtra('Page', pageName)),
  withAnalyticOnView<PageProps>({
    analyticName: 'PageView',
    mapPropsToExtras: ({ mapPropsToExtras, ...props }) => (mapPropsToExtras ? mapPropsToExtras(props) : {}),
  }),
  withPageMeasurement
)(Page);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/Page.tsx